/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetAssistantMemorySecurity = {
  projectSlugHeaderGramProject?: string | undefined;
  sessionHeaderGramSession?: string | undefined;
};

export type GetAssistantMemoryRequest = {
  /**
   * The assistant memory ID.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type GetAssistantMemorySecurity$Outbound = {
  "project_slug_header_Gram-Project"?: string | undefined;
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const GetAssistantMemorySecurity$outboundSchema: z.ZodMiniType<
  GetAssistantMemorySecurity$Outbound,
  GetAssistantMemorySecurity
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.optional(z.string()),
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getAssistantMemorySecurityToJSON(
  getAssistantMemorySecurity: GetAssistantMemorySecurity,
): string {
  return JSON.stringify(
    GetAssistantMemorySecurity$outboundSchema.parse(getAssistantMemorySecurity),
  );
}

/** @internal */
export type GetAssistantMemoryRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const GetAssistantMemoryRequest$outboundSchema: z.ZodMiniType<
  GetAssistantMemoryRequest$Outbound,
  GetAssistantMemoryRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
    });
  }),
);

export function getAssistantMemoryRequestToJSON(
  getAssistantMemoryRequest: GetAssistantMemoryRequest,
): string {
  return JSON.stringify(
    GetAssistantMemoryRequest$outboundSchema.parse(getAssistantMemoryRequest),
  );
}
